module.exports = __webpack_public_path__ + "static/img/invest-consume3.723ca60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-consume3.jpg
// module id = unPz
// module chunks = 0